import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InternalContainer from '../../layout/containers/Internal';
import Campaigns from '../components/Campaigns/Campaigns';
import SalesBannerForm from '../components/SalesBannerForm/SalesBannerForm';
import { createCampaign } from '../redux/campaignActions';
import InternalTabs from '../../layout/components/InternalTabs/InternalTabs';

const TAB_NAME = 'campaignTabs';

class CampaignsList extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    content: PropTypes.object.isRequired,
  };

  handleSubmit(resource) {
    return this.props.dispatch(createCampaign(resource));
  }

  render() {
    return (
      <InternalContainer title="Campaigns">
        <InternalTabs
          id={TAB_NAME}
          tabs={[
            {
              permissions: ['marketing.campaign_view'],
              title: 'Campaigns',
              content: <Campaigns {...this.props} />,
            },
            {
              permissions: ['marketing.campaign_view', 'content_management.view'],
              title: 'Sales Banner',
              content: <SalesBannerForm onSubmit={null} />,
            },
          ]}
        />
      </InternalContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    content: state.content,
  };
}

export default connect(mapStateToProps)(CampaignsList);
